import { ChevronRight } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import brandLogo from '../../../../../public/brands/evolution.png';

interface BrandItemProps {
  imgSrc?: string;
}
const BrandItem: React.FC<BrandItemProps> = ({ imgSrc }) => {
  return (
    <div className="relative h-[45px] w-full flex items-center justify-center border-2 border-[#801C80]/70 bg-[#1E1B4B] rounded-sm overflow-hidden">
      <Image
        src={imgSrc || brandLogo}
        alt="brand logo"
        fill
        className="object-contain object-center p-1"
        priority
      />
    </div>
  );
};
export const TopBrands = () => {
  return (
    <div className="py-4">
      <div className="flex justify-between">
        <h4 className="font-bold text-sm text-[#FFA035] px-4 pb-2">
          TOP Providers
        </h4>
        <Link
          href="/pages/m-providers"
          className="text-[10px] text-white flex items-center gap-1 px-4 cursor-pointer hover:opacity-80 active:opacity-70"
        >
          more providers <ChevronRight className="size-3" />
        </Link>
      </div>

      <div className="p-2 grid grid-cols-4 gap-2 rounded-lg mx-2">
        <BrandItem imgSrc="/provider/3-oaks.png" />
        <BrandItem imgSrc="/provider/288.png" />
        <BrandItem imgSrc="/provider/b-gaming.png" />
        <BrandItem imgSrc="/provider/belatra.png" />
        <BrandItem imgSrc="/provider/blueprint.png" />
        <BrandItem imgSrc="/provider/golden-hero.png" />
        <BrandItem imgSrc="/provider/habanero.png" />
        <BrandItem imgSrc="/provider/hacksaw.png" />
      </div>
    </div>
  );
};
